import { render, staticRenderFns } from "./SlackIntegrationHelpText.vue?vue&type=template&id=60735c6c&"
import script from "./SlackIntegrationHelpText.vue?vue&type=script&lang=js&"
export * from "./SlackIntegrationHelpText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports